import { types } from "../../../types/types";

const initialState = {
  items: [],
  loading: false,
  itemsPracticas : []
};

export const abmCosegurosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.abmCosegurosTraerStart:
      return {
        ...state,
        loading: true,
        items: [],
        itemsPracticas: [],
      };
    case types.abmCosegurosTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        itemsPracticas: [],
      };
    case types.abmCosegurosTraerError:
      return {
        ...state,
        loading: false,
      };
      case types.abmCosegurosPracticasClean:
        return {
          ...state,
          itemsPracticas: [],
        };
    case types.abmCosegurosPracticasTraerSuccess:
      return {
        ...state,
        itemsPracticas: action.payload,
      };
    case types.abmCosegurosPracticasTraerError:
      return {
        ...state,
        loading: false,
        itemsPracticas: [],
      };
    default:
      return state;
  }
};
